import { ContractVersion } from '~/typings/context';

export const getContractMap = (contracts: ContractVersion[]): Record<string, any> => {
  const contractsMap = {};
  contracts.forEach(contract => {
    contractsMap[contract.displayName] = contract;
  });
  return contractsMap;
};

export const getConsentMap = (consents: any[]): Record<string, any> => {
  const consentMap = {};
  consents.forEach(consent => {
    consentMap[consent.internalName] = consent;
  });
  return consentMap;
};
